import React from 'react';
import { animateScroll as scroll } from 'react-scroll';
import { FaArrowUp } from 'react-icons/fa';

const BackToTopButton: React.FC = () => {
  const scrollToTop = () => {
    scroll.scrollToTop();
  };

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-8 right-8 p-3 bg-customGreen text-white border-2 border-customGreen rounded-full shadow-lg hover:bg-transparent hover:text-customGreen transition duration-300 z-50"
    >
      <FaArrowUp />
    </button>
  );
};

export default BackToTopButton;
